<div class="dialog-buttons">
  <p-button
    variant="outlined"
    severity="danger"
    [label]="'Annuleren' | translate"
    severity="secondary"
    icon="pi pi-times"
    (onClick)="onCancel()"
  />
  <p-button variant="outlined" severity="success" icon="pi pi-check" [label]="'Opslaan' | translate" (onClick)="onSubmit()" />
</div>
